import { jsx as _jsx } from "react/jsx-runtime";
// ESLint's react/require-default-props rule does not recognise forwardRef-wrapped components
// as functional components, so it fires even though defaults are in the destructuring.
/* eslint-disable react/require-default-props */
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Form } from 'antd';
import { Speaker } from 'api/speaker';
import { txt } from 'libs/i18n';
import { SpeakerTreeSelect } from '../../SpeakerTreeSelect';
const SelectTab = forwardRef(({ form, onChangeTab, onClose, onSubmit, defaultSpeakerColor = undefined, }, ref) => {
    const treeSelectRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focusSearchInput: () => { var _a; (_a = treeSelectRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
    }), []);
    const handleAction = (action) => {
        if (action.kind === 'addSpeaker') {
            onChangeTab('create', action.searchText !== undefined ? { searchText: action.searchText } : undefined);
            return;
        }
        if (action.kind === 'addRole') {
            onChangeTab('edit', {
                id: action.speakerId,
                openAddRoleModal: true,
                firstName: action.firstName,
                lastName: action.lastName,
            });
            return;
        }
        // 'editSpeaker' action
        onChangeTab('edit', { id: action.speakerId, firstName: action.firstName, lastName: action.lastName });
    };
    const handleValuesChange = (changedValues) => {
        var _a, _b, _c, _d;
        if (changedValues.speaker === undefined) {
            return;
        }
        const { speaker, roleIndex } = changedValues.speaker;
        const role = roleIndex === 'none'
            ? null
            : speaker.savedInDb
                ? ((_c = (_b = (_a = speaker.children) === null || _a === void 0 ? void 0 : _a[roleIndex]) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : null)
                : speaker.role;
        const newSpeaker = new Speaker(speaker.firstName, speaker.lastName, role, speaker.id, speaker.dbid, speaker.diarizationCode, speaker.isUnknown, speaker.language, speaker.unmaintainedMetadata, (_d = speaker.captionColor) !== null && _d !== void 0 ? _d : defaultSpeakerColor, speaker.isDefaultColor);
        onSubmit(newSpeaker);
        onClose();
    };
    return (_jsx(Form, { form: form, layout: "vertical", onValuesChange: handleValuesChange, initialValues: { speaker: undefined }, children: _jsx(Form.Item, { name: "speaker", label: txt('oneSpeaker').replace(/^./, (c) => c.toUpperCase()), labelCol: { span: 24 }, wrapperCol: { span: 24 }, rules: [{ required: true, message: txt('speakerRequired') }], children: _jsx(SpeakerTreeSelect, { ref: treeSelectRef, autoFocus: true, onAction: handleAction, helperText: txt('selectSpeakerHint') }) }) }));
});
export default SelectTab;
